// src/lib/api.js
// Talks to the Closet Collective API project (a separate Vercel deployment) for platform
// OAuth + listing creation. Set REACT_APP_API_URL in this site's Vercel env to the API
// project's URL (e.g. https://closet-collective-api.vercel.app). Functions live under /api.
const API = `${process.env.REACT_APP_API_URL || ""}/api`;

export async function getConnectionStatus() {
  try {
    const res = await fetch(`${API}/status`);
    return res.ok ? res.json() : { etsy: false, ebay: false };
  } catch {
    return { etsy: false, ebay: false };
  }
}

export function connectEtsy() {
  window.location.href = `${API}/etsy-auth`;
}

export function connectEbay() {
  window.location.href = `${API}/ebay-auth`;
}

export async function disconnectPlatform(platform) {
  await fetch(`${API}/${platform}-auth`, { method: "DELETE" });
}

export async function postToEtsy(listing) {
  const res = await fetch(`${API}/etsy-create-listing`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(listing),
  });
  return res.json();
}

export async function postToEbay(listing) {
  const res = await fetch(`${API}/ebay-create-listing`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(listing),
  });
  return res.json();
}
